import { MessageSquare, Map, CreditCard, HeartHandshake } from "lucide-react";

const steps = [
  {
    icon: MessageSquare,
    step: "01",
    title: "Share Your Travel Plan",
    description: "Tell us your dream destination, dates, and preferences.",
  },
  {
    icon: Map,
    step: "02",
    title: "We Design Your Itinerary",
    description: "Our experts craft a personalized travel plan just for you.",
  },
  {
    icon: CreditCard,
    step: "03",
    title: "We Book Everything",
    description: "Flights, hotels, visas – we handle all the logistics.",
  },
  {
    icon: HeartHandshake,
    step: "04",
    title: "Support Until You Return",
    description: "24/7 assistance before, during, and after your trip.",
  },
];

export const HowItWorks = () => {
  return (
    <section className="section-padding bg-background" aria-labelledby="how-it-works-heading">
      <div className="container-luxury">
        <div className="text-center space-y-4 mb-14">
          <span className="section-badge">Simple Process</span>
          <h2 id="how-it-works-heading" className="section-title">
            How It Works
          </h2>
          <p className="section-subtitle">
            Four simple steps to your perfect vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((item, index) => (
            <div key={index} className="relative">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-px bg-border" />
              )}
              
              <div className="luxury-card p-8 text-center space-y-5 hover-lift relative z-10">
                <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center mx-auto">
                  <item.icon className="h-7 w-7" aria-hidden="true" />
                </div>
                <div className="text-3xl font-bold text-gradient-gold">{item.step}</div>
                <h3 className="font-heading font-semibold text-lg">{item.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};